import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const SPARKLES = ['✨', '💖', '⭐', '💕', '🌟', '💗', '⭐️'];
export function SparkleEffect() {
  const [sparkles, setSparkles] = useState<Array<{
    id: number;
    x: number;
    y: number;
    emoji: string;
    size: number;
    duration: number;
  }>>([]);
  useEffect(() => {
    // Generate random sparkles across the screen
    const newSparkles = Array.from({
      length: 30
    }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      emoji: SPARKLES[Math.floor(Math.random() * SPARKLES.length)],
      size: Math.random() * 20 + 10,
      duration: Math.random() * 2 + 1.5
    }));
    setSparkles(newSparkles);
  }, []);
  return <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" data-id="element-185">
      {sparkles.map(sparkle => <motion.div key={sparkle.id} className="absolute" style={{
      left: `${sparkle.x}%`,
      top: `${sparkle.y}%`,
      fontSize: `${sparkle.size}px`
    }} animate={{
      y: [0, -20, 0],
      opacity: [0.2, 1, 0.2],
      scale: [0.8, 1.2, 0.8],
      rotate: [0, 180, 360]
    }} transition={{
      duration: sparkle.duration,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-186">
          {sparkle.emoji}
        </motion.div>)}
    </div>;
}